import React from "react";
import { Link as NavLink } from "react-router-dom";
import {
  VStack,
  HStack,
  UnorderedList,
  ListItem,
  Link,
  Box,
} from "@chakra-ui/react";

import { AuxiliaryComponent, getHumanReadableAuxPartType } from "@constants";
import {
  IconTagFailed,
  IconTagLocation,
  IconTagPassed,
  PlainTag,
} from "@components";
import { convertTimestampToDate } from "@utils";

type ComponentInfoProps = {
  auxiliaryComponent: AuxiliaryComponent;
};

export function ComponentInfo({ auxiliaryComponent }: ComponentInfoProps) {
  return (
    <VStack padding="4px" gap="4px" alignItems="stretch">
      <HStack>
        {auxiliaryComponent.status === "OKAY" ? (
          <IconTagPassed text="Okay" />
        ) : null}
        {auxiliaryComponent.status === "IN_USE" ? (
          <IconTagPassed text="In Use" />
        ) : null}
        {auxiliaryComponent.status === "DO_NOT_USE" ? (
          <IconTagFailed text="Do No Use" />
        ) : null}
        <IconTagLocation location={auxiliaryComponent.location} />
        <PlainTag text={auxiliaryComponent.componentCategory} />
        <PlainTag
          text={getHumanReadableAuxPartType(auxiliaryComponent.componentType)}
        />
      </HStack>
      <Box>
        <UnorderedList>
          <ListItem>
            {"Registered On: "}
            {convertTimestampToDate(
              auxiliaryComponent.registeredOn,
            ).toLocaleDateString()}
          </ListItem>
          {auxiliaryComponent.expirationDate ? (
            <ListItem>
              {"Expired On: "}
              {convertTimestampToDate(
                auxiliaryComponent.expirationDate,
              ).toLocaleDateString()}
            </ListItem>
          ) : undefined}
          <ListItem>
            {"Registered By: "}
            <Link
              as={NavLink}
              to={`/users/${auxiliaryComponent.registeredBy.authId}`}
            >
              {auxiliaryComponent.registeredBy.name}
            </Link>
          </ListItem>
        </UnorderedList>
      </Box>
    </VStack>
  );
}
